module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/74027_power_pxiI_t2.jpg"
    }
  })])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I believe we are all born with amazing powers and the greatest power of all is our ability to make an impact on people’s lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You’ve been using your power to impact people since the first moment you moved inside your mother’s womb. With one little kick, you touched the very core of her being and moved her to think, feel and act in ways she’d never done before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And ever since that first moment of impact, you’ve touched hundreds, maybe even thousands of lives—simply by being you and interacting with people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every email, every text, every post, every tweet, the simple act of ordering a cup of coffee, answering your phone or smiling at a stranger...")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything you do and everything you "), _c('i', [_vm._v("don’t")]), _vm._v(" do has an impact on someone else—and when you purposefully infuse your unique impact into your message, products and services, that’s when you’ll see its greatest power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("As a pebble creates ripples in a pond, moving further and further from the point of origin, so will your impact spread far beyond your reach. Make your impact "), _c('i', [_vm._v("measurable")]), _vm._v(" and the vast majority of people you’ll touch over the course of your entire life will be people you’ll never meet! Because when you impact just one person, s/he will change in some way and then carry your impact on to someone else. And your ripple will move on, with one person touching another in an endless cycle of impact.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('b', [_vm._v("The more effective your impact, the more it will stretch around the globe and extend far into the future touching generations yet unborn.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That is the power of impact. And it all begins with you. You were born with the amazing power to make a unique impact on people’s lives and I believe life’s most important journey is discovering how you’re going to use this powerful gift—before it’s too late and you miss your chance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m writing this book because I want you to have the formulas you need to make the greatest impact possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So let’s do this. Because the world needs your impact now. And because life is far too short to settle for less than you truly want—in your business or your life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you for giving me the privilege of guiding you on your Journey of Impact.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/74027_13_p147_t2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f15977","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Power.vue
// module id = 84
// module chunks = 0